import { useMemo } from 'react'
import TournamentItem from '../../../../../../components/list-items/components/tournamentItem'
import PaginatedList from '../../../../../../components/PaginatedList'
import { useCommunityTournaments } from '../../hooks/useCommunityData'

import styles from './styles.module.scss'

const TournamentsList = ({ communityId }) => {
  const {
    data: tournaments,
    pagination,
    isLoading,
    handlePageChange,
  } = useCommunityTournaments(communityId)

  const renderTournament = useMemo(
    () => tournament => <TournamentItem {...tournament} />,
    []
  )

  return (
    <PaginatedList
      items={tournaments}
      pagination={pagination}
      isLoading={isLoading}
      renderItem={renderTournament}
      itemKey='uuid'
      onPageChange={handlePageChange}
      className={styles.events__cards}
      listClassName={styles.event__list__events}
      data-testid='community-tournaments-section'
    />
  )
}

export default TournamentsList
